import './App.css';
import Footer from './AllComponents/Footer/Footer';
import Dashboard from './AllComponents/MainComponent/Dashboard';
import { Route, Routes, useNavigate } from 'react-router-dom';
import SidebarNav from './AllComponents/NavigationComponent/SidebarNav';
import { useEffect, useState } from 'react';
import LoginPage from './AllComponents/LoginPage/LoginPage';

//==========General Master========================
import DesignationMaster from './AllComponents/MainComponent/Masters/GeneralMaster/DesignationMaster';
import DepartmentMaster from './AllComponents/MainComponent/Masters/GeneralMaster/DepartmentMaster';
import EmployeeMaster from './AllComponents/MainComponent/Masters/GeneralMaster/EmployeeMaster';
import AlloyMaster from './AllComponents/MainComponent/Masters/GeneralMaster/AlloyMaster';
import PressMaster from './AllComponents/MainComponent/Masters/GeneralMaster/PressMaster';
import JobWorkerMaster from './AllComponents/MainComponent/Masters/GeneralMaster/JobWorkerMaster';
import HSNCodeMaster from './AllComponents/MainComponent/Masters/GeneralMaster/HSNCodeMaster';
import BankDetailsMaster from './AllComponents/MainComponent/Masters/GeneralMaster/BankDetailsMaster';
import JobWorkerProcessMaster from './AllComponents/MainComponent/Masters/GeneralMaster/JobWorkerProcessMaster';
import SupplierMaster from './AllComponents/MainComponent/Masters/GeneralMaster/SupplierMaster';
import UOMMaster from './AllComponents/MainComponent/Masters/GeneralMaster/UOMMaster';
import JobWorkerItemMaster from './AllComponents/MainComponent/Masters/GeneralMaster/JobWorkerItemMaster';

//==========Purchase Master========================
import TermsAndConditionMaster from './AllComponents/MainComponent/Masters/PurchaseMaster/TermsAndConditionMaster';

//==========Dies Master========================
import DieCategoryMaster from './AllComponents/MainComponent/Masters/DiesMaster/DieCategoryMaster';
import DieSubCategoryMaster from './AllComponents/MainComponent/Masters/DiesMaster/DieSubCategoryMaster';
import DieNameMaster from './AllComponents/MainComponent/Masters/DiesMaster/DieNameMaster';
import DiesMaster from './AllComponents/MainComponent/Masters/DiesMaster/DiesMaster';
import DieAssemblyMaster from './AllComponents/MainComponent/Masters/DiesMaster/DieAssemblyMaster';
import DiaMaster from './AllComponents/MainComponent/Masters/DiesMaster/DiaMaster';

//==========Sales Master========================
import CustomerMaster from './AllComponents/MainComponent/Masters/SalesMaster/CustomerMaster';
import ConsigneeMaster from './AllComponents/MainComponent/Masters/SalesMaster/ConsigneeMaster';
import RateMaster from './AllComponents/MainComponent/Masters/SalesMaster/RateMaster';

//==========Production Master========================
import RackMaster from './AllComponents/MainComponent/Masters/ProductionMaster/RackMaster';
import MachineMaster from './AllComponents/MainComponent/Masters/ProductionMaster/MachineMaster';
import TemperMaster from './AllComponents/MainComponent/Masters/ProductionMaster/TemperMaster';
import ShiftMaster from './AllComponents/MainComponent/Masters/ProductionMaster/ShiftMaster';
import HeaderNav from './AllComponents/NavigationComponent/HeaderNav';

//==========DIE SHOP========================
import CustomerWiseDieReport from './AllComponents/MainComponent/DieShop/CustomerWiseDieReport';
import NitradingDueReport from './AllComponents/MainComponent/DieShop/NitradingDueReport';
import DieNameWiseReport from './AllComponents/MainComponent/DieShop/DieNameWiseReport';
import DieWiseReport from './AllComponents/MainComponent/DieShop/DieWiseReport';
import DieStatusChange from './AllComponents/MainComponent/DieShop/DieStatusChange';
import NitradingEntry from './AllComponents/MainComponent/DieShop/NitradingEntry';

//==========SALES===========================
import StockChecking from './AllComponents/MainComponent/Sales/StockChecking';
import OrderAllotment from './AllComponents/MainComponent/Sales/OrderAllotment';
import JobSheetClosure from './AllComponents/MainComponent/Sales/JobSheetClosure';
import RateApproval from './AllComponents/MainComponent/Sales/RateApproval';
import JobSheetApproval from './AllComponents/MainComponent/Sales/JobSheetApproval';
import OrderStatus from './AllComponents/MainComponent/Sales/OrderStatus';
import PreOrderEntry from './AllComponents/MainComponent/Sales/PreOrderEntry';
import OrderEntry from './AllComponents/MainComponent/Sales/OrderEntry';

//==========SALES ORDER REPORT===========================
import RackWiseDetails from './AllComponents/MainComponent/SalesOrderReport/RackWiseDetails';
import ItemStock from './AllComponents/MainComponent/SalesOrderReport/ItemStock';
import PackingList from './AllComponents/MainComponent/SalesOrderReport/PackingList';
import SalesDetailRegister from './AllComponents/MainComponent/SalesOrderReport/SalesDetailRegister';
import SalesItemWiseReport from './AllComponents/MainComponent/SalesOrderReport/SalesItemWiseReport';

//==========PRODUCTION ORDER===========================
import PendingOrderSummary from './AllComponents/MainComponent/ProductionOrder/PendingOrderSummary';
import Order from './AllComponents/MainComponent/ProductionOrder/Order';

//==========PRODUCTION===========================
import ReleaseRack from './AllComponents/MainComponent/Production/ReleaseRack';
import Packing from './AllComponents/MainComponent/Production/Packing';
import RackRemark from './AllComponents/MainComponent/Production/RackRemark';
import Ageins from './AllComponents/MainComponent/Production/Ageins';
import CloseRack from './AllComponents/MainComponent/Production/CloseRack';
import PressOutput from './AllComponents/MainComponent/Production/PressOutput';
import PressInput from './AllComponents/MainComponent/Production/PressInput';

//==========PRODUCTION REPORTS===========================
import ManufactureReport from './AllComponents/MainComponent/ProductionReport/ManufactureReport';
import PackingRejectionReport from './AllComponents/MainComponent/ProductionReport/PackingRejectionReport';
import AgeingReport from './AllComponents/MainComponent/ProductionReport/AgeingReport';

//==========DISPATCH===========================
import MiscellaneousUpdate from './AllComponents/MainComponent/Dispatch/MiscellaneousUpdate';
import JobWorkDispatch from './AllComponents/MainComponent/Dispatch/JobWorkDispatch';
import JobWork from './AllComponents/MainComponent/Dispatch/JobWork';
import Dispatch from './AllComponents/MainComponent/Dispatch/Dispatch';

//==========QUOTATION===========================
import Proforma from './AllComponents/MainComponent/Quotation/Proforma';
import Quotation from './AllComponents/MainComponent/Quotation/Quotation';

//==========PROFORMA INVOICE===========================
import ProformaInvoice from './AllComponents/MainComponent/ProformaInvoice/ProformaInvoice';
import JobSheetApprovalDetails from './AllComponents/MainComponent/Sales/JobSheetApprovalDetails';
import RateSheetApprovalDetails from './AllComponents/MainComponent/Sales/RateSheetApprovalDetails';
import OrderAllotmentDetails from './AllComponents/MainComponent/Sales/OrderAllotmentDetails';
import JobWorkDeliverySummary from './AllComponents/MainComponent/Dispatch/JobWorkDeliverySummary';
import DispatchDeliverySummary from './AllComponents/MainComponent/Dispatch/DispatchDeliverySummary';



function App() {

  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    const token  = sessionStorage.getItem("authToken");
    if (token  !== null) {
      setIsLoggedIn(true);
    }
  }, []);
  

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    sessionStorage.removeItem("userData");
    sessionStorage.clear();
    navigate('/');

  };



  return (
    <div
    className="container-fluid p-0"
    style={{ height: "100vh", display: "flex", flexDirection: "column" }}
  >


    <div
        className="wrapper"
        style={{
          display: "flex",
          flex: "1",
         overflow: "hidden" ,
        }}
      >
        {isLoggedIn && (
          <SidebarNav />
        )}

        <main className="main" style={{ flex: "1", overflowY: "auto" }}>

            {isLoggedIn && (
            <HeaderNav
              className="header-nav p-0 shadow"
              handleLogout={handleLogout}
            />
          )}
          
          <Routes>

            {!isLoggedIn && (
              <Route
                path="/"
                element={<LoginPage onLogin={handleLogin} />}
              />
            )}
          

{/* ~~~~~~DASHBOARD~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/dashboard" element={<Dashboard />} />}

{/* ~~~~~~MASTERS~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}

            {/* ================GENERAL MASTER============================ */}
            {isLoggedIn && <Route path="/gm1" element={<DesignationMaster />} />}
            {isLoggedIn && <Route path="/gm2" element={<DepartmentMaster />} />}
            {isLoggedIn && <Route path="/gm3" element={<EmployeeMaster />} />}
            {isLoggedIn && <Route path="/gm4" element={<AlloyMaster />} />}
            {isLoggedIn && <Route path="/gm5" element={<PressMaster />} />}
            {isLoggedIn && <Route path="/gm6" element={<JobWorkerMaster />} />}
            {isLoggedIn && <Route path="/gm7" element={<HSNCodeMaster />} />}
            {isLoggedIn && <Route path="/gm8" element={<BankDetailsMaster />} />}
            {isLoggedIn && <Route path="/gm9" element={<UOMMaster />} />}
            {isLoggedIn && <Route path="/gm10" element={<SupplierMaster />} />}
            {isLoggedIn && <Route path="/gm11" element={<JobWorkerProcessMaster />} />}
            {isLoggedIn && <Route path="/gm12" element={<JobWorkerItemMaster />} />}

            {/* ================PURCHASE MASTER=========================== */}
            {isLoggedIn && <Route path="/purchasem1" element={<TermsAndConditionMaster />} />}

            {/* ================DIES MASTER=========================== */}
            {isLoggedIn && <Route path="/dm1" element={<DieCategoryMaster />} />}
            {isLoggedIn && <Route path="/dm2" element={<DieSubCategoryMaster />} />}
            {isLoggedIn && <Route path="/dm3" element={<DieNameMaster />} />}
            {isLoggedIn && <Route path="/dm4" element={<DiesMaster />} />}
            {isLoggedIn && <Route path="/dm5" element={<DieAssemblyMaster />} />}
            {isLoggedIn && <Route path="/dm6" element={<DiaMaster />} />}

            {/* ================SALES MASTER=========================== */}
            {isLoggedIn && <Route path="/sm1" element={<CustomerMaster />} />}
            {isLoggedIn && <Route path="/sm2" element={<ConsigneeMaster />} />}
            {isLoggedIn && <Route path="/sm3" element={<RateMaster />} />}
            
            {/* ================PRODUCTION MASTER=========================== */}
            {isLoggedIn && <Route path="/pm1" element={<MachineMaster />} />}
            {isLoggedIn && <Route path="/pm2" element={<RackMaster />} />}
            {isLoggedIn && <Route path="/pm3" element={<ShiftMaster />} />}
            {isLoggedIn && <Route path="/pm4" element={<TemperMaster />} />}

{/* ~~~~~~DIE SHOP~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/dieshop1" element={<NitradingEntry />} />}
            {isLoggedIn && <Route path="/dieshop2" element={<DieStatusChange />} />}
            {isLoggedIn && <Route path="/dieshop3" element={<DieWiseReport />} />}
            {isLoggedIn && <Route path="/dieshop4" element={<DieNameWiseReport />} />}
            {isLoggedIn && <Route path="/dieshop5" element={<NitradingDueReport />} />}
            {isLoggedIn && <Route path="/dieshop6" element={<CustomerWiseDieReport />} />}

{/* ~~~~~~SALES~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/sales1" element={<OrderEntry />} />}
            {isLoggedIn && <Route path="/sales2" element={<PreOrderEntry />} />}
            {isLoggedIn && <Route path="/sales3" element={<OrderStatus />} />}
            {isLoggedIn && <Route path="/sales4" element={<JobSheetApproval />} />}
            {isLoggedIn && <Route path="/sales5" element={<RateApproval />} />}
            {isLoggedIn && <Route path="/sales6" element={<JobSheetClosure />} />}
            {isLoggedIn && <Route path="/sales7" element={<OrderAllotment />} />}
            {isLoggedIn && <Route path="/sales8" element={<StockChecking />} />}
            <Route path="/jobsheet-details/:orderId" element={<JobSheetApprovalDetails/>} />
            <Route path="/ratesheet-details/:orderId" element={<RateSheetApprovalDetails/>} />
            <Route path="/orderallotment-details/:orderId" element={<OrderAllotmentDetails/>} />
            

{/* ~~~~~~SALES ORDER REPORT~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/salesorder1" element={<SalesItemWiseReport />} />}
            {isLoggedIn && <Route path="/salesorder2" element={<SalesDetailRegister />} />}
            {isLoggedIn && <Route path="/salesorder3" element={<PackingList />} />}
            {isLoggedIn && <Route path="/salesorder4" element={<ItemStock />} />}
            {isLoggedIn && <Route path="/salesorder5" element={<RackWiseDetails />} />}

{/* ~~~~~~PRODUCTION ORDER~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/porder1" element={<PendingOrderSummary />} />}
            {isLoggedIn && <Route path="/porder2" element={<Order />} />}

{/* ~~~~~~PRODUCTION~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/production1" element={<PressInput />} />}
            {isLoggedIn && <Route path="/production2" element={<PressOutput />} />}
            {isLoggedIn && <Route path="/production3" element={<CloseRack />} />}
            {isLoggedIn && <Route path="/production4" element={<Ageins />} />}
            {isLoggedIn && <Route path="/production5" element={<RackRemark />} />}
            {isLoggedIn && <Route path="/production6" element={<Packing />} />}
            {isLoggedIn && <Route path="/production7" element={<ReleaseRack />} />}

{/* ~~~~~~PRODUCTION REPORTS~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/preport1" element={<AgeingReport />} />}
            {isLoggedIn && <Route path="/preport2" element={<PackingRejectionReport />} />}
            {isLoggedIn && <Route path="/preport3" element={<ManufactureReport />} />}

{/* ~~~~~~DISPATCH~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/dispatch1" element={<Dispatch />} />}
            {isLoggedIn && <Route path="/dispatch2" element={<JobWork />} />}
            {isLoggedIn && <Route path="/dispatch3" element={<JobWorkDispatch />} />}
            {isLoggedIn && <Route path="/dispatch4" element={<MiscellaneousUpdate />} />}
            {isLoggedIn && <Route path="/dispatch5" element={<DispatchDeliverySummary />} />}
            {isLoggedIn && <Route path="/dispatch6" element={<JobWorkDeliverySummary />} />}

{/* ~~~~~~QUOTATION~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/quotation1" element={<Quotation />} />}
            {isLoggedIn && <Route path="/quotation2" element={<Proforma />} />}

{/* ~~~~~~PROFORMA INVOICE~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */}
            {isLoggedIn && <Route path="/pinvoice-1" element={<ProformaInvoice />} />}


          </Routes>
        </main>
      </div>


{isLoggedIn && <Footer />}
</div>

  );
}

export default App;
